import dynamic from "next/dynamic";
import * as Sentry from "@sentry/nextjs";

import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { dehydrate, QueryClient } from '@tanstack/react-query';
import { getQueryFn } from "../utils/api/queryFunction";

const NotFoundResponse = dynamic(() => import("./404"));

const MaintenanceResponse = () => (
	<div className="errorBody main500">
		<div>
			<img
				className="responsiveImage main404"
				src="/static/img/503image.jpg"
			/>
		</div>
	</div>
);

const InternalServerErrorResponse = () => (
	<div className="errorBody main500">
		<div>
			<img
				className="responsiveImage main404"
				// src="/static/img/500image.jpg"
				src="/static/img/maps/error/500image.jpg"
			/>
			<div className="main404Page">
				<a
					title="Back"
					href="/"
					className="whiteRedBtn waves-effect waves-light btn-large"
				>
					Go Back
				</a>
			</div>
		</div>
	</div>
);

const RedirectResponse = ({ redirectDestUrl, errCode }) => {
	return (
		<div className="errorBody main500">
			<div>
				<img
					className="responsiveImage main404"
					src={`/static/img/${errCode}Error.jpg`}
				/>
				<div className="main404Page">
					<p>Click here if you're not redirected shortly</p>
					<a
						title="Back"
						href={redirectDestUrl || '/'}
						className="whiteRedBtn waves-effect waves-light btn-large"
					>
						TAKE ME THERE
					</a>
				</div>
			</div>
		</div>
	);
};


const CustomError = (props) => {
	let { error, errorCode } = props;

	const [errorData, setErrorData] = useState({});
	const [renderErrorPage, setRenderErrorPage] = useState(false);

	const router = useRouter();

	useEffect(async () => {
		if (errorCode === 301 || errorCode === 302) {
			const timer = setTimeout(() => {
				router.push(props.error.redirectDestUrl);
			}, 500);
			return () => clearTimeout(timer);
		}

		if (errorCode === 404) {
			const data = await getQueryFn(`${errorCode}`);
			setErrorData(data);
			setRenderErrorPage(true);
		}
	}, []);

	switch (errorCode) {
		case 301:
		case 302:
			return (<RedirectResponse redirectDestUrl={props.error.redirectDestUrl} errCode={errorCode} />);
		case 0:
		case 200:
		case 404:
			return (renderErrorPage ? <NotFoundResponse data={errorData} /> : null);
		case 500:
			return (<InternalServerErrorResponse />);
		case 503:
			return (<MaintenanceResponse />);
		default:
			return (<InternalServerErrorResponse />);
	}
};

CustomError.getInitialProps = async (context) => {
	const queryClient = new QueryClient();

	await Sentry.captureUnderscoreErrorException(context);
	
	await queryClient.prefetchQuery(['error-404'], () => getQueryFn('404'));

	return {
		dehydratedState: dehydrate(queryClient)
	};
};

export default CustomError;
